import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { FlagProvider } from '@unleash/proxy-client-react';
const FeatureFlagProvider = ({ children }) => {
    const state = useSelector((state) => state);
    const config = {
        url: APP.UNLEASH_SERVER_API_URL,
        clientKey: APP.UNLEASH_SERVER_API_TOKEN,
        refreshInterval: 15,
        appName: APP.UNLEASH_SERVER_APP_NAME,
    };
    return (_jsx(FlagProvider, { config: {
            ...config,
            context: {
                // @ts-expect-error State has a type Unknown
                accessId: state.event.data.venue.id,
            },
        }, children: children }));
};
export default FeatureFlagProvider;
